// Background dot spacing, after tessera's gridSpacing: step the board-space
// spacing by powers of 4 so on-screen spacing stays between MIN and MAX px.

const BASE = 24
const MIN_SCREEN = 14
const MAX_SCREEN = 64

export function gridSpacing(zoom: number): number {
  let s = BASE
  while (s * zoom < MIN_SCREEN) s *= 4
  while (s * zoom > MAX_SCREEN) s /= 4
  return s
}
